<p-scrollPanel [style]="{height: 'calc(75vh)'}">
    <div class="mos-header">
        <div class="headertitle">Approve & Activate</div>
        <span>Are these details correct?</span>
    </div>
    <div class="description">
        <span>Customer has requested activation:<input type="text" pInputText  class="asap" [(ngModel)]="Asap"/></span>
    </div>
   <div class="container"> 
    <div class="promo">
      <div>The customer has the following promotions</div>
       <span>- Free commission 30 days</span>
        <div>The customer has the following ad credits</div>
        <span>None</span>
      </div>
    </div>

    <div class="mos-btn-block">
        <div class="mos-btn-block__label">
            <p>By activating this store, the partner will receive a email notification Xpress Account Manager & Xpress Marketing will also be notified via email If you would like to notify anyone else, please add email below.</p>
        </div>
        <input type="text" pInputText placeholder="enter email address" class="email" [(ngModel)]="otherEmail"/>
        <div class="btn">
            <button pButton pRipple type="button" label="Back" class="bluedark-btn"></button>
            <button pButton pRipple type="button" label="Confirm" class="bluedark-btn" (click)="confirmMerchant()"></button>
        </div>
    </div>
</p-scrollPanel>
